(() => {
  const init = () => {
    document.querySelectorAll('.gw-universal-lightbox,.gw-pants-lightbox,.gw-shorts-lightbox').forEach(dialog => {
      if (dialog.dataset.gwMagnifierBound) return;
      dialog.dataset.gwMagnifierBound = 'true';
      const track = dialog.querySelector('[class$="lightbox__track"]');
      if (!track) return;
      const lens = document.createElement('div');
      lens.className = 'gw-gallery-lens';
      lens.hidden = true;
      lens.setAttribute('aria-hidden', 'true');
      lens.style.cssText = 'position:absolute;width:180px;height:180px;border:1px solid #111;border-radius:50%;background-color:#e7e7e7;background-repeat:no-repeat;pointer-events:none;z-index:10;box-sizing:border-box';
      dialog.append(lens);
      const hide = () => { lens.hidden = true; lens.style.display = 'none'; };
      hide();
      dialog.addEventListener('mousemove', event => {
        if (!dialog.open || window.innerWidth < 750 || event.target.closest('button')) { hide(); return; }
        const image = Array.from(track.querySelectorAll('img')).find(img => {
          const r = img.getBoundingClientRect();
          return event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
        });
        if (!image || !image.complete || !image.naturalWidth || !image.naturalHeight) { hide(); return; }
        const rect = image.getBoundingClientRect();
        const scale = Math.min(rect.width / image.naturalWidth, rect.height / image.naturalHeight);
        const width = image.naturalWidth * scale, height = image.naturalHeight * scale;
        const x = event.clientX - rect.left - (rect.width - width) / 2;
        const y = event.clientY - rect.top - (rect.height - height) / 2;
        if (x < 0 || y < 0 || x > width || y > height) { hide(); return; }
        const bounds = dialog.getBoundingClientRect(), half = 90, zoom = 2.5;
        lens.style.left = Math.max(0, Math.min(bounds.width - 180, event.clientX - bounds.left - half)) + 'px';
        lens.style.top = Math.max(0, Math.min(bounds.height - 180, event.clientY - bounds.top - half)) + 'px';
        const source = image.currentSrc || image.src;
        if (lens.dataset.source !== source) {
          lens.style.backgroundImage = 'url(' + JSON.stringify(source) + ')';
          lens.dataset.source = source;
        }
        lens.style.backgroundSize = (width * zoom) + 'px ' + (height * zoom) + 'px';
        lens.style.backgroundPosition = (half - x * zoom) + 'px ' + (half - y * zoom) + 'px';
        lens.hidden = false;
        lens.style.display = 'block';
      });
      dialog.addEventListener('mouseleave', hide);
      dialog.addEventListener('close', hide);
      dialog.addEventListener('click', hide);
      document.addEventListener('keydown', hide);
      window.addEventListener('resize', hide);
      new MutationObserver(hide).observe(track, { childList: true, attributes: true, attributeFilter: ['style'] });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('gw:product:updated', init);
})();